import { gql } from '@apollo/client';

export const LOG_EVENT = gql`
  mutation LogEvent($data: String!) {
    logEvent(data: $data) {
      success
    }
  }
`;
